<template>
    <div id="debug-activate-profile-page">
        <ui5-button id="cancel" @click="$router.push('/debugmenu')">
            {{ trans('pages.debug_activate_profile.back') }}
        </ui5-button>
        <div>
            <h2>{{ trans('pages.debug_activate_profile.title') }}</h2>
            <p v-html="trans('pages.debug_activate_profile.instruction')"></p>
            <div class="form-container">
                <ui5-input
                    type="Text"
                    @input="code = $event.target.value"
                    :value="code"
                    @keyup.enter="activate" />
                <ui5-button @click="activate">{{ trans('pages.debug_activate_profile.activate_button') }}</ui5-button>
            </div>
            <div v-if="activating">{{ trans('pages.debug_activate_profile.activating') }}</div>
            <div v-else-if="lastCode">
                <span class="error" v-if="error">
                    {{ trans('pages.debug_activate_profile.code_not_exists', { code: lastCode }) }}
                </span>
                <span class="success" v-else>
                    {{ trans('pages.debug_activate_profile.code_activated', { code: lastCode }) }}
                </span>
            </div>
            <h3>
                {{ trans('pages.debug_activate_profile.inactive_profiles_title') }}
                <i @click="loadList" class="fa fa-refresh" />
            </h3>
            <table>
                <thead>
                    <tr>
                        <th>{{ trans('pages.debug_activate_profile.table.id') }}</th>
                        <th>{{ trans('pages.debug_activate_profile.table.code') }}</th>
                        <th>{{ trans('pages.debug_activate_profile.table.description') }}</th>
                    </tr>
                </thead>
                <tbody id="inactives" v-if="list">
                    <tr v-for="profile in list" :key="profile.ID">
                        <td>{{ profile.ID }}</td>
                        <td class="code-column" @click="paste(profile.code)">
                            {{ profile.code }}
                        </td>
                        <td>{{ profile.description }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import profileApi from './../api/profile';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            list: null,
            code: '',
            lastCode: null,
            activating: false,
            error: false,
        };
    },
    methods: {
        paste(code) {
            this.code = code;
            window.document.body.scrollTop = 0;
            window.document.documentElement.scrollTop = 0;
        },
        activate() {
            const code = this.code;
            this.activating = true;
            this.error = false;
            this.lastCode = code;
            profileApi
                .activate(code)
                .then(() => {
                    this.error = false;
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.activating = false;
                });
        },
        loadList() {
            this.list = null;
            profileApi
                .listInactive()
                .then((response) => {
                    this.list = response.data.data;
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.debug_activate_profile.error_listing_profiles'));
                });
        },
    },
    mounted() {
        this.loadList();
    },
};
</script>
